module.exports = __webpack_public_path__ + "static/media/calvin-klein.7a3c3327.jpg";